module.exports = __webpack_public_path__ + "static/media/CNX-CNX-30-IQ.e0ef1fed.jpg";